export const DEFAULT_LANGUAGE = 'US'
export const SUPPORTED_LANGUAGES = ['CN', 'US', 'TW', 'DE', 'ES', 'JA', 'KO', 'TR']

export const LANGUAGE_ALIASES = {
  'zh': 'CN',
  'zh-cn': 'CN',
  'zh_cn': 'CN',
  'zh-hans': 'CN',
  'zh-hans-cn': 'CN',
  'zh-tw': 'TW',
  'zh_hant': 'TW',
  'zh-hant': 'TW',
  'zh-hk': 'TW',
  'en': 'US',
  'en-us': 'US',
  'en-gb': 'US',
  'de': 'DE',
  'de-de': 'DE',
  'es': 'ES',
  'es-es': 'ES',
  'tr': 'TR',
  'tr-tr': 'TR',
  'ja': 'JA',
  'jp': 'JA',
  'ja-jp': 'JA',
  'ko': 'KO',
  'kr': 'KO',
  'ko-kr': 'KO'
}

// normalizeLocale 将 URL、浏览器、Cookie、JSBridge 等语言输入统一成服务端短码。
export const normalizeLocale = (locale) => {
  if (!locale) return DEFAULT_LANGUAGE
  const lower = locale.toLowerCase()
  if (LANGUAGE_ALIASES[lower]) {
    return LANGUAGE_ALIASES[lower]
  }
  const base = lower.split(/[-_]/)[0]
  const candidate = base.toUpperCase()
  return SUPPORTED_LANGUAGES.includes(candidate) ? candidate : DEFAULT_LANGUAGE
}

// getBrowserLocale 读取浏览器首选语言，不支持或读取失败时回退英文。
export const getBrowserLocale = () => {
  try {
    if (typeof navigator !== 'undefined' && navigator.language) {
      return normalizeLocale(navigator.language)
    }
  } catch (error) {
    console.warn('获取浏览器语言失败:', error)
  }
  return DEFAULT_LANGUAGE
}
